import {filtersData, IFiltersData} from '../utils';
import {useAdvertisementFilters} from '../../../../../hooks/filters/useAdvertisementFilter';

const Chip = ({
  onRemove,
  children,
}: {
  onRemove: () => void;
  children: React.ReactNode;
}) => (
  <div className="flex items-center border-[1px] text-sm text-farm-shop-600 rounded-full bg-farm-shop-100 w-fit py-2 px-2 whitespace-nowrap">
    {children}
    <i className="mr-3 text-lg icon-nameClose-remove" onClick={onRemove} />
  </div>
);

const FiltersAdvertisementList = ({
  inputGroupName,
}: {
  inputGroupName?: string;
}) => {
  const {filters, setFilter, resetFilter} = useAdvertisementFilters();

  return (
    <div className="flex gap-2 items-center">
      {filters.input_group_guid?.map(group => (
        <Chip
          key={group.guid}
          onRemove={() =>
            setFilter(
              'input_group_guid',
              filters.input_group_guid.filter(g => g.guid !== group.guid),
            )
          }
        >
          {group.title}
        </Chip>
      ))}
      {filters.input_guid?.map(group => (
        <Chip
          key={group.guid}
          onRemove={() =>
            setFilter(
              'input_guid',
              filters.input_guid.filter(g => g.guid !== group.guid),
            )
          }
        >
          {group.title}
        </Chip>
      ))}
      {filters.order_by && (
        <Chip onRemove={() => resetFilter('order_by')}>
          {
            filtersData(inputGroupName as string)?.find(
              (item: IFiltersData) => item.value === filters.order_by,
            )?.title
          }
        </Chip>
      )}
      {filters.has_immediate && (
        <Chip onRemove={() => resetFilter('has_immediate')}>
          <span>آگهی‌های فوری</span>
        </Chip>
      )}
      {filters.has_special_offer && (
        <Chip onRemove={() => resetFilter('has_special_offer')}>
          <span>پیشنهادات شگفت‌انگیز</span>
        </Chip>
      )}
      {filters.has_store && (
        <Chip onRemove={() => resetFilter('has_store')}>
          <span>آگهی فروشگاه‌ها</span>
        </Chip>
      )}
      {filters.has_price && (
        <Chip onRemove={() => resetFilter('has_price')}>
          <span>آگهی‌های دارای قیمت</span>
        </Chip>
      )}
      {filters.start_price !== undefined && (
        <Chip onRemove={() => resetFilter('start_price')}>
          <span> از قیمت {filters.start_price}</span>
        </Chip>
      )}
      {filters.end_price !== undefined && (
        <Chip onRemove={() => resetFilter('end_price')}>
          <span> تا قیمت {filters.end_price}</span>
        </Chip>
      )}
    </div>
  );
};

export default FiltersAdvertisementList;
